import { DocumentTree } from 'src/redux/types/documents';

export const checkIsDocumentTreeExpanded = (tree: DocumentTree, folderId: string) => {
	if (tree.id === folderId) return true;

	return tree.children.some((c) => checkIsDocumentTreeExpanded(c, folderId));
};
